<template>
  <div style="height: 100%; min-width: 1400px">
    <div class="layout" v-if="false">
      <Sider
        :style="{
          position: 'fixed',
          height: '100vh',
          left: 0,
          overflow: 'auto',
          width: '260px',
          maxWidth: 'auto',
          zIndex: '999',
        }"
      >
        <div style="background: #06364b; height: 64px">
          <img src="./assets/image/logo.png" style="margin: 14px 0 0 28px" />
        </div>
        <Menu
          ref="side_menu"
          :active-name="activeName"
          theme="light"
          width="auto"
          :open-names="openNames"
          class="menuList"
        >
          <MenuItem name="/" to="/">
            <template> <i class="el-icon-s-help"></i>技术指标可视化 </template>
          </MenuItem>

          <MenuItem name="factorAnalysisNav" to="/factorAnalysisNav">
            <template>
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: middle; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M8,1 C4.13793103,1 1,4.13793103 1,8 C1,11.862069 4.13793103,15 8,15 C11.862069,15 15,11.862069 15,8 C15,4.13793103 11.862069,1 8,1 Z M11.9827586,9.81034483 C11.9747126,9.81034483 11.9747126,9.81034483 11.9827586,9.81034483 L10.3333333,9.81034483 C10.1885057,9.81034483 10.0597701,9.70574713 10.0356322,9.56091954 L9.74597701,7.82298851 L8.65977011,11.5965517 C8.61954023,11.7252874 8.50689655,11.8137931 8.37011494,11.8137931 L8.36206897,11.8137931 C8.22528736,11.8057471 8.1045977,11.7091954 8.08045977,11.5724138 L6.81724138,5.6908046 L6.02068966,9.07816092 C5.98850575,9.21494253 5.86781609,9.31149425 5.72298851,9.31149425 L4.01724138,9.31149425 C3.86436782,9.31149425 3.73563218,9.18275862 3.73563218,9.02988506 C3.73563218,8.87701149 3.86436782,8.74827586 4.01724138,8.74827586 L5.52183908,8.74827586 L6.53563218,4.42758621 C6.56781609,4.2908046 6.68850575,4.19425287 6.83333333,4.19425287 C6.97816092,4.19425287 7.09885057,4.2908046 7.12298851,4.43563218 L8.39425287,10.437931 L9.5045977,6.55977011 C9.54482759,6.42298851 9.66551724,6.33448276 9.81034483,6.34252874 C9.95517241,6.35057471 10.0678161,6.45517241 10.091954,6.59195402 L10.5425287,9.24712644 L11.9747126,9.24712644 C12.1275862,9.24712644 12.2563218,9.37586207 12.2563218,9.52873563 C12.2643678,9.6816092 12.1356322,9.81034483 11.9827586,9.81034483 L11.9827586,9.81034483 Z"
                />
              </svg>
              因子分析
            </template>
          </MenuItem>

          <MenuItem name="experimentNav" to="/experimentNav">
            <template>
              <i class="ivu-icon ivu-icon-ios-nuclear"></i>
              金融市场整体策略实验
            </template>
          </MenuItem>

          <Submenu v-if="false" name="technical">
            <template slot="title">
              <i class="el-icon-s-help"></i>技术指标可视化
              <!-- <Icon type="ios-navigate"></Icon> -->
            </template>
            <MenuItem name="home" to="/home">
              <svg
                t="1597473098279"
                viewBox="0 0 1026 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2182"
                width="17"
                height="15"
                style="vertical-align: middle; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M59.733333 910.222222V51.2h-56.888889v910.222222h1024V910.222222z"
                  p-id="2183"
                />
                <path
                  d="M258.844444 620.088889h56.888889v-85.333333h56.888889v-227.555556h-56.888889v-56.888889h-56.888889v56.888889h-56.888888v227.555556h56.888888zM514.844444 790.755556h56.888889v-256h56.888889v-341.333334h-56.888889v-113.777778h-56.888889v113.777778h-56.888888v341.333334h56.888888zM770.844444 705.422222h56.888889v-142.222222h56.888889v-199.111111h-56.888889v-142.222222h-56.888889v142.222222h-56.888888v199.111111h56.888888z"
                  p-id="2184"
                /></svg
              >K线图
            </MenuItem>
            <!-- <MenuItem name="timesharing" to="/technical/timesharing">
            <Icon type="ios-navigate"></Icon>分时图
          </MenuItem>-->
            <MenuItem name="mastermap" to="/technical/mastermap">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: middle; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M15.4670131,12.9230769 L1.07636689,12.9230769 L1.07636689,8.34076923 L4.14850336,5.23707692 C4.34890644,5.32969231 4.57062899,5.38461538 4.80727517,5.38461538 C5.04392135,5.38461538 5.26457793,5.32969231 5.46604697,5.23707692 L7.61824806,7.41138462 C7.52550834,7.61384615 7.47220965,7.83892308 7.47220965,8.07692308 C7.47220965,8.96861538 8.18854404,9.69230769 9.07117034,9.69230769 C9.95379664,9.69230769 10.670131,8.96861538 10.670131,8.07692308 C10.670131,7.83892308 10.6157664,7.61384615 10.5240926,7.41138462 L15.8113226,2.06984615 C16.041573,1.83830769 16.041573,1.46246154 15.8113226,1.22984615 C15.5821383,0.998307692 15.2101134,0.998307692 14.9798631,1.22984615 L9.6787754,6.58430769 C9.49116402,6.50569231 9.28649705,6.46153846 9.07117034,6.46153846 C8.85584364,6.46153846 8.65011069,6.50569231 8.46249931,6.58430769 L6.28471485,4.38307692 C6.36501203,4.18859603 6.4063165,3.97995235 6.40623586,3.76923077 C6.40623586,2.87753846 5.68990147,2.15384615 4.80727517,2.15384615 C3.92464887,2.15384615 3.20831448,2.87753846 3.20831448,3.76923077 C3.20823383,3.97995235 3.2495383,4.18859603 3.32983549,4.38307692 L1.07636689,6.66076923 L1.07636689,0.538461538 C1.07636689,0.241230769 0.837588762,0 0.543379995,0 C0.249171228,0 0.0103930984,0.241230769 0.0103930984,0.538461538 L0.0103930984,7.89707692 C-0.00346436614,7.96855168 -0.00346436614,8.0420637 0.0103930984,8.11353846 L0.0103930984,13.4615385 C0.0103930984,13.7587692 0.249171228,14 0.543379995,14 L15.4670131,14 C15.7612219,14 16,13.7587692 16,13.4615385 C16,13.1643077 15.7612219,12.9230769 15.4670131,12.9230769 Z M9.07117034,7.53846154 C9.36537911,7.53846154 9.60415724,7.77969231 9.60415724,8.07692308 C9.60415724,8.37415385 9.36537911,8.61538462 9.07117034,8.61538462 C8.77696158,8.61538462 8.53818345,8.37415385 8.53818345,8.07692308 C8.53818345,7.77969231 8.7758956,7.53846154 9.07117034,7.53846154 Z M4.80727517,3.23076923 C5.10148394,3.23076923 5.34026207,3.472 5.34026207,3.76923077 C5.34026207,4.06646154 5.10148394,4.30769231 4.80727517,4.30769231 C4.5130664,4.30769231 4.27428827,4.06646154 4.27428827,3.76923077 C4.27428827,3.472 4.51200043,3.23076923 4.80727517,3.23076923 Z"
                /></svg
              >主图指标
            </MenuItem>
            <MenuItem name="picture" to="/technical/picture">
              <svg
                t="1597473370533"
                viewBox="0 0 1194 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="14"
                style="vertical-align: middle; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M85.333333 938.666667h1066.666667c25.6 0 42.666667 17.066667 42.666667 42.666666s-17.066667 42.666667-42.666667 42.666667H42.666667c-8.533333 0-25.6-8.533333-34.133334-8.533333 0-8.533333-8.533333-25.6-8.533333-34.133334V42.666667C0 17.066667 17.066667 0 42.666667 0s42.666667 17.066667 42.666666 42.666667V938.666667z m401.066667-657.066667c17.066667-17.066667 42.666667-25.6 59.733333-8.533333l8.533334 8.533333 8.533333 8.533333 196.266667 213.333334 315.733333-341.333334c17.066667-17.066667 42.666667-17.066667 59.733333 0s17.066667 42.666667 0 59.733334l-341.333333 366.933333c-17.066667 17.066667-42.666667 17.066667-68.266667-8.533333L520.533333 375.466667l-256 281.6c-17.066667 17.066667-42.666667 17.066667-59.733333 0-17.066667-17.066667-17.066667-42.666667 0-59.733334l281.6-315.733333z"
                  p-id="3797"
                /></svg
              >副图指标
            </MenuItem>
          </Submenu>
          <Submenu v-if="false" name="factorAnalysis">
            <template slot="title">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: middle; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M8,1 C4.13793103,1 1,4.13793103 1,8 C1,11.862069 4.13793103,15 8,15 C11.862069,15 15,11.862069 15,8 C15,4.13793103 11.862069,1 8,1 Z M11.9827586,9.81034483 C11.9747126,9.81034483 11.9747126,9.81034483 11.9827586,9.81034483 L10.3333333,9.81034483 C10.1885057,9.81034483 10.0597701,9.70574713 10.0356322,9.56091954 L9.74597701,7.82298851 L8.65977011,11.5965517 C8.61954023,11.7252874 8.50689655,11.8137931 8.37011494,11.8137931 L8.36206897,11.8137931 C8.22528736,11.8057471 8.1045977,11.7091954 8.08045977,11.5724138 L6.81724138,5.6908046 L6.02068966,9.07816092 C5.98850575,9.21494253 5.86781609,9.31149425 5.72298851,9.31149425 L4.01724138,9.31149425 C3.86436782,9.31149425 3.73563218,9.18275862 3.73563218,9.02988506 C3.73563218,8.87701149 3.86436782,8.74827586 4.01724138,8.74827586 L5.52183908,8.74827586 L6.53563218,4.42758621 C6.56781609,4.2908046 6.68850575,4.19425287 6.83333333,4.19425287 C6.97816092,4.19425287 7.09885057,4.2908046 7.12298851,4.43563218 L8.39425287,10.437931 L9.5045977,6.55977011 C9.54482759,6.42298851 9.66551724,6.33448276 9.81034483,6.34252874 C9.95517241,6.35057471 10.0678161,6.45517241 10.091954,6.59195402 L10.5425287,9.24712644 L11.9747126,9.24712644 C12.1275862,9.24712644 12.2563218,9.37586207 12.2563218,9.52873563 C12.2643678,9.6816092 12.1356322,9.81034483 11.9827586,9.81034483 L11.9827586,9.81034483 Z"
                />
              </svg>
              因子分析
            </template>
            <MenuItem name="singlefactor" to="/factorAnalysis/singlefactor">
              <!-- <Icon type="ios-navigate"></Icon> -->
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: sub; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M14.245283,4 C13.2830189,4 12.490566,4.81461287 12.490566,5.81570338 C12.490566,6.32606325 12.6981132,6.78735005 13.0188679,7.12104689 L11,9.70229008 C10.7169811,9.48636859 10.3584906,9.35877863 9.98113208,9.35877863 C9.43396226,9.35877863 8.95283019,9.61395856 8.62264151,10.0261723 L7.49056604,8.41657579 C7.94339623,8.08287895 8.23584906,7.54307525 8.23584906,6.92475463 C8.23584906,5.92366412 7.45283019,5.10905125 6.48113208,5.10905125 C5.50943396,5.10905125 4.72641509,5.92366412 4.72641509,6.92475463 C4.72641509,7.02290076 4.73584906,7.12104689 4.74528302,7.21919302 L3.01886792,8.55398037 C2.69811321,8.21046892 2.25471698,7.99454744 1.75471698,7.99454744 C0.79245283,7.99454744 0,8.80916031 0,9.81025082 C0,10.8113413 0.783018868,11.6259542 1.75471698,11.6259542 C2.71698113,11.6259542 3.50943396,10.8113413 3.50943396,9.81025082 C3.50943396,9.55507088 3.46226415,9.31952017 3.36792453,9.10359869 L4.98113208,7.86695747 C5.29245283,8.39694656 5.83962264,8.74045802 6.48113208,8.74045802 C6.62264151,8.74045802 6.76415094,8.72082879 6.89622642,8.69138495 L8.29245283,10.6837514 C8.24528302,10.8407852 8.22641509,11.0076336 8.22641509,11.1842966 C8.22641509,12.1853871 9.00943396,13 9.98113208,13 C10.9433962,13 11.7358491,12.1853871 11.7358491,11.1842966 C11.7358491,10.8113413 11.6320755,10.4678299 11.4433962,10.1832061 L13.5566038,7.49400218 C13.7641509,7.59214831 14,7.64122137 14.245283,7.64122137 C15.2169811,7.64122137 16,6.82660851 16,5.82551799 C16,4.81461287 15.2169811,4 14.245283,4 L14.245283,4 Z M1.76415094,10.6444929 C1.32075472,10.6444929 0.962264151,10.2715376 0.962264151,9.81025082 C0.962264151,9.34896401 1.32075472,8.97600872 1.76415094,8.97600872 C2.20754717,8.97600872 2.56603774,9.34896401 2.56603774,9.81025082 C2.56603774,10.2715376 2.20754717,10.6444929 1.76415094,10.6444929 Z M5.67924528,6.92475463 C5.67924528,6.46346783 6.03773585,6.09051254 6.48113208,6.09051254 C6.9245283,6.09051254 7.28301887,6.46346783 7.28301887,6.92475463 C7.28301887,7.38604144 6.9245283,7.75899673 6.48113208,7.75899673 C6.03773585,7.75899673 5.67924528,7.38604144 5.67924528,6.92475463 Z M9.99056604,12.0283533 C9.54716981,12.0283533 9.18867925,11.655398 9.18867925,11.1941112 C9.18867925,10.7328244 9.54716981,10.3598691 9.99056604,10.3598691 C10.4339623,10.3598691 10.7924528,10.7328244 10.7924528,11.1941112 C10.7924528,11.655398 10.4339623,12.0283533 9.99056604,12.0283533 Z M14.245283,6.65976009 C13.8018868,6.65976009 13.4433962,6.2868048 13.4433962,5.82551799 C13.4433962,5.36423119 13.8018868,4.9912759 14.245283,4.9912759 C14.6886792,4.9912759 15.0471698,5.36423119 15.0471698,5.82551799 C15.0566038,6.2868048 14.6981132,6.65976009 14.245283,6.65976009 Z"
                  id="menu_icon_7_xuanzhong"
                />
              </svg>
              单标的因子分析
            </MenuItem>
            <MenuItem name="singleanalysis" to="/factorAnalysis/singleanalysis">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: sub; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M16,7.10715028 L16,7.10715028 L16,2 L0.000290617623,2 L0.000290617623,10.0478139 L0,10.0469804 L0.00346921792,10.9755532 L0.00395962739,10.9757237 L0.000272441818,15 L16,15 L16,8.03572307 L16,8.03572307 L16,7.10715028 L16,7.10715028 Z M1,3 L15,3 L15,6.99109095 L11.675589,6.99109095 L11.1687401,10 L9.08572541,3.40448425 L6.75097627,9.87527334 L4.60543927,5.6295547 L2.16710632,9.79299063 L1,9.79688042 L1,3 Z M1,10.8435151 L2.60314651,10.8375131 L4.41278727,7.41078613 L6.65877115,12.3425357 L8.72281927,6 L11,14 L1,14 L1,10.8435151 Z M15,14 L11,14 L12.0917104,8 L15,8 L15,14 L15,14 Z"
                /></svg
              >单天、单因子、多标的分析
            </MenuItem>
            <MenuItem name="aloneanalysis" to="/factorAnalysis/aloneanalysis">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: sub; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M2.59726006,5.00465601 C1.16513713,5.00465601 8.8817842e-16,3.88210563 8.8817842e-16,2.50232801 C8.8817842e-16,1.12255038 1.16513713,0 2.59726006,0 C4.02938298,0 5.19452011,1.12255038 5.19452011,2.50232801 C5.19452011,3.88210563 4.02938298,5.00465601 2.59726006,5.00465601 Z M2.59726006,1.22307158 C1.86394288,1.22307158 1.26947185,1.79581419 1.26947185,2.50232801 C1.26947185,3.20884182 1.86394288,3.78158443 2.59726006,3.78158443 C3.33057724,3.78158443 3.92504827,3.20884182 3.92504827,2.50232801 C3.9243921,1.79607621 3.33030527,1.22370376 2.59726006,1.22307158 Z M12.4027399,5.99457957 C13.8348629,5.99457957 15,7.11712995 15,8.49690757 C15,9.8766852 13.8348629,11 12.4027399,11 C10.970617,11 9.80547989,9.8766852 9.80547989,8.49652536 C9.80547989,7.11636553 10.970617,5.99457957 12.4027399,5.99457957 L12.4027399,5.99457957 Z M12.4027399,9.776164 C13.1360055,9.77616397 13.7304551,9.20349899 13.7305281,8.49703494 C13.7306011,7.79057089 13.1362699,7.21779188 12.4030043,7.21765115 C11.6697388,7.21751047 11.0751708,7.79006134 11.0749517,8.49652536 C11.0749517,9.2032249 11.6692303,9.77629556 12.4027399,9.77692842 L12.4027399,9.776164 Z"
                />
                <path
                  d="M6.63737966,2 L14.3626203,2 C14.7875401,2 15,2.16666667 15,2.5 L15,2.5 C15,2.83333333 14.7875401,3 14.3626203,3 L6.63737966,3 C6.21245989,3 6,2.83333333 6,2.5 L6,2.5 C6,2.16666667 6.21245989,2 6.63737966,2 Z"
                />
                <path
                  d="M8.36262034,9 L0.637379661,9 C0.212459887,9 0,8.83333333 0,8.5 L0,8.5 C0,8.16666667 0.212459887,8 0.637379661,8 L8.36262034,8 C8.78754011,8 9,8.16666667 9,8.5 L9,8.5 C9,8.83333333 8.78754011,9 8.36262034,9 Z"
                />
              </svg>
              单因子分析
            </MenuItem>
            <MenuItem name="multiplefactor" to="/factorAnalysis/multiplefactor">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: sub; margin-right: 6px"
                class="svgLi"
              >
                <path
                  d="M16,7.10715028 L16,7.10715028 L16,2 L0.000290617623,2 L0.000290617623,10.0478139 L0,10.0469804 L0.00346921792,10.9755532 L0.00395962739,10.9757237 L0.000272441818,15 L16,15 L16,8.03572307 L16,8.03572307 L16,7.10715028 L16,7.10715028 Z M1,3 L15,3 L15,6.99109095 L11.675589,6.99109095 L11.1687401,10 L9.08572541,3.40448425 L6.75097627,9.87527334 L4.60543927,5.6295547 L2.16710632,9.79299063 L1,9.79688042 L1,3 Z M1,10.8435151 L2.60314651,10.8375131 L4.41278727,7.41078613 L6.65877115,12.3425357 L8.72281927,6 L11,14 L1,14 L1,10.8435151 Z M15,14 L11,14 L12.0917104,8 L15,8 L15,14 L15,14 Z"
                /></svg
              >单天、多因子、多标的分析
            </MenuItem>
          </Submenu>
          <Submenu v-if="false" name="experiment">
            <template slot="title">
              <i class="ivu-icon ivu-icon-ios-nuclear"></i>
              金融市场整体策略实验
            </template>
            <!-- :name="'experiment?id='+item.strategyNo" -->
            <MenuItem
              v-for="(item, idx) in strategy"
              :key="idx + 'i'"
              :name="'/experiment/' + item.strategyNo"
              :to="'/experiment/' + item.strategyNo"
            >
              <!-- <Icon type="ios-shuffle" class="font16"></Icon> -->
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                style="vertical-align: sub; margin-right: 6px"
                class="svgLi"
              >
                <polygon
                  points="13.1591899 8.52810651 12.3051297 9.50493097 13.7073632 11.1065089 10.80901 11.1065089 8.64660231 8 10.80901 4.89349112 13.7073632 4.89349112 12.3051297 6.49506903 13.1591899 7.46844181 15.1429112 5.21104536 16 4.23422091 15.1429112 3.25739645 13.1591899 1 12.3051297 1.97682446 13.6528488 3.51282051 10.2244937 3.51282051 7.87431384 6.88856016 5.52413401 3.51282051 0 3.51282051 0 4.89349112 4.93961764 4.89349112 7.10202536 8 4.93961764 11.1065089 0 11.1065089 0 12.4871795 5.52413401 12.4871795 7.87431384 9.11143984 10.2244937 12.4871795 13.6528488 12.4871795 12.3051297 14.0231755 13.1591899 15 15.1429112 12.7426036 16 11.7657791 15.1429112 10.7889546"
                />
              </svg>
              {{ item.strategyName }}
            </MenuItem>
          </Submenu>
        </Menu>
      </Sider>
      <Layout :style="{ marginLeft: '260px', zIndex: '4' }">
        <Header class="layout-header">
          <p class="header_tit">
            基于股票多因子策略模型的量化金融虚拟仿真实验教学项目
          </p>
        </Header>
        <Content style="margin-top: 64px">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="breadcrumb"
            v-if="breadcrumbData.type"
          >
            <el-breadcrumb-item :to="{ path: breadcrumbData.navURL }">{{
              breadcrumbData.navName
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ breadcrumbData.name }}</el-breadcrumb-item>
          </el-breadcrumb>
          <router-view style="padding: 16px"></router-view>
        </Content>
      </Layout>
    </div>
    <div class="logo">
      <router-link to="/homeNav">
        <img src="./assets/image/logo.png" />
      </router-link>
      <p class="header_tit">
        基于股票多因子策略模型的量化金融虚拟仿真实验教学项目
      </p>
      <router-link to="/homeNav" title="回到首页">
        <i class="el-icon-s-home planHome"></i>
      </router-link>
    </div>
    <router-view class="routerView"></router-view>
  </div>
</template>

<script>
import "./assets/less/index.less";

export default {
  data() {
    return {
      activeName: "",
      breadcrumbData: {
        name: "",
        navName: "",
        navURL: "/",
        type: false,
      },
      openNames: [],
      strategy: [],
      show: false,
    };
  },
  created() {},
  mounted() {
    localStorage.removeItem("experimentId");
    localStorage.removeItem("userId");
    localStorage.removeItem("schoolId");
    localStorage.setItem("startDate", new Date().getTime());

    if (!sessionStorage.getItem("sessionId")) {
      this.sessionId();
    }
    this.setTimeInit();
  },
  methods: {
    setTimeInit() {
      // setTimeout(() => {
      //   this.$api.hubei.sessionKeep().then((res) => {
      //     this.setTimeInit();
      //   });
      // }, 3000);
    },
    sessionId() {
      this.$api.hubei.sessionId().then((res) => {
        sessionStorage.setItem("sessionId", res);
      });
    },
    getStrategyList() {
      this.$api.hubei.getStrategyList().then((res) => {
        this.strategy = res;
        localStorage.setItem("MENUS", JSON.stringify(res));
      });
    },
    ngOnInit() {
      const { path } = this.$route;
      this.openNames = ["1"];
    },
  },

  watch: {
    $route: {
      handler(val, oldval) {
        if (val.query.experimentId) {
          localStorage.setItem("experimentId", val.query.experimentId);
        }
        if (val.query.schoolId) {
          localStorage.setItem("schoolId", val.query.schoolId);
        }
        if (val.query.userId) {
          localStorage.setItem("userId", val.query.userId);
        }

        if (sessionStorage.getItem("clickObj")) {
          let objAttr = JSON.parse(sessionStorage.getItem("clickObj"));
          if (objAttr.filter((item) => item == this.$route.path).length == 0) {
            objAttr.push(this.$route.path);
          }
          sessionStorage.setItem("clickObj", JSON.stringify(objAttr));
        } else {
          let objAttr = [];
          objAttr.push(this.$route.path);
          sessionStorage.setItem("clickObj", JSON.stringify(objAttr));
        }
        const path = val.path;
        this.openNames = [];
        this.breadcrumbData.name = val.name;
        if (
          path == "/" ||
          path == "/home" ||
          path.slice(0, path.lastIndexOf("/")) == "/technical"
        ) {
          this.activeName = "/";
          this.openNames = ["technical"];
          this.breadcrumbData.type = val.fullPath == "/" ? false : true;
          this.breadcrumbData.navURL = "/";
          this.breadcrumbData.navName = "技术指标可视化";
        } else if (path.slice(0, path.lastIndexOf("/")) == "/factorAnalysis") {
          this.openNames = ["factorAnalysisNav"];
          this.activeName = "factorAnalysisNav";
          this.breadcrumbData.type =
            val.fullPath == "/factorAnalysisNav" ? false : true;
          this.breadcrumbData.navURL = "/factorAnalysisNav";
          this.breadcrumbData.navName = "因子分析";
        } else if (path.slice(0, path.lastIndexOf("/")) == "/experiment") {
          this.openNames = ["experimentNav"];
          this.activeName = "experimentNav";
          this.breadcrumbData.type = false;
          // this.breadcrumbData.type = val.fullPath=="/experimentNav"?false:true;
          // this.breadcrumbData.navURL = '/experimentNav';
          // this.breadcrumbData.navName = "首页";
          // this.breadcrumbData.navName = "金融市场整体策略实验";
        } else {
          this.breadcrumbData.type = false;
          this.activeName = path.slice(path.lastIndexOf("/") + 1);
          this.openNames.push(path.slice(1, path.lastIndexOf("/")));
        }
        // this.$nextTick(() => {
        //   this.$refs.side_menu.updateOpened();
        //   this.$refs.side_menu.updateActiveName();
        // });
        // val新路由信息;oldval老路由信息
      },
    },
  },
};
</script>

<style lang="less" scoped>
// 面包屑
.breadcrumb {
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  padding-left: 20px;
  background: #f7f9ff;
}
.layout {
  // border: 1px solid #d7dde4;
  background: #f7f9ff;
  border-radius: 4px;
  min-width: 1288px;
  .ivu-layout-sider .menuList {
    background: none;
  }
  .ivu-layout {
    background: #f7f9ff;
  }
  // overflow: hidden;
  // overflow-x: auto;
  .layout-header {
    background: url("./assets/image/bgnav.png") no-repeat center;
    background-size: 100% 100%;
    padding: 0;
    position: fixed;
    top: 0;
    right: 0;
    left: 260px;
    z-index: 9999;
    .header_tit {
      font-size: 18px;
      font-family: "MicrosoftYaHei";
      color: rgba(255, 255, 255, 1);
      display: block;
      padding-left: 20px;
      background: linear-gradient(
        270deg,
        rgba(99, 154, 177, 0.17) 0%,
        rgba(6, 54, 75, 1) 100%
      );
    }
    .ivu-dropdown {
      display: flex;
      align-items: center;
    }
    .user {
      margin-right: 20px;
      display: block;
      width: 44px;
      height: 44px;
      .admin-avatar {
        width: 44px;
        height: 44px;
      }
    }
  }
  .ivu-menu-vertical.ivu-menu-light:after {
    background: none;
  }
  .layout-header-bar {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  }
  .ivu-layout-sider,
  .ivu-menu-dark,
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
    // background: #001529;
    background: linear-gradient(
      180deg,
      rgba(0, 61, 86, 1) 0%,
      rgba(0, 21, 43, 1) 100%
    );
  }

  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
    // background: #001529;
    background: linear-gradient(
      180deg,
      rgba(0, 61, 86, 1) 0%,
      rgba(0, 21, 43, 1) 100%
    );
  }

  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
    // background: #001529;
    background: linear-gradient(
      180deg,
      rgba(0, 61, 86, 1) 0%,
      rgba(0, 21, 43, 1) 100%
    );
  }

  .ivu-menu {
    background: #000c17;
  }
}
.layout-login {
  width: 100%;
  height: 100vh;
  position: relative;
}
.ivu-message {
  z-index: 5400 !important;
}
.ivu-modal-mask,
.ivu-modal-wrap {
  z-index: 2008 !important;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  color: #57a3ef;
  background: #184a7d;
  z-index: 2;
  .svgLi {
    fill: #57a3ef;
  }
}
.layout /deep/ .ivu-menu-vertical .ivu-menu-item:hover,
.layout /deep/ .ivu-menu-vertical .ivu-menu-submenu-title:hover {
  .svgLi {
    fill: #57a3ef;
  }
  color: #57a3ef;
  fill: #57a3ef;
}
.svgLi {
  fill: #fff;
}
.layout /deep/ .ivu-menu-vertical .ivu-menu-submenu-title {
  font-size: 14px;
  color: #fff;
}
.layout /deep/ .ivu-menu-vertical .ivu-menu-item {
  font-size: 14px;
  color: #fff;
}
.layout /deep/ .ivu-menu-vertical .ivu-menu-item {
  // padding-left: 30px !important;
  padding-right: 10px !important;
}
.font16 {
  font-size: 16px;
}

.routerView {
  // padding: 16px;
  // width: 1500px;
  // margin: 0 auto;
  height: calc(100% - 64px);
}
.logo {
  background: #042841;
  height: 64px;
  position: relative;
  img {
    float: left;
    margin: 14px 0 0 28px;
  }
  .header_tit {
    float: left;
    font-size: 22px;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    margin-left: 65px;
    line-height: 64px;
  }
}
.planHome {
  color: #70bfea;
  font-size: 27px;
  border: 3px solid #70bfea;
  border-radius: 10px;
  padding: 7px;
  float: right;
  margin-right: 30px;
  transition: all 1s;
  z-index: 9;
  position: absolute;
  right: 30px;
  top: 8px;
}
.planHome:hover {
  transform: scale(1.1);
}
</style>